/**
 * haptics.js - Native Mobile Haptic Feedback Utility
 * Provides subtle, tactile feedback patterns for modern web apps on mobile devices.
 */

const canVibrate =
  typeof window !== "undefined" &&
  typeof navigator !== "undefined" &&
  typeof navigator.vibrate === "function";

export const haptic = {
  /**
   * Subtle tick (10ms) - for toggles, switches, tabs, small adjustments
   */
  light: () => {
    if (!canVibrate) return;
    try {
      navigator.vibrate(10);
    } catch (_) {}
  },

  /**
   * Standard selection tap (15ms) - for selecting a car, payment method, counter +/-
   */
  selection: () => {
    if (!canVibrate) return;
    try {
      navigator.vibrate(15);
    } catch (_) {}
  },

  /**
   * Medium impact (25ms) - for step progression, major buttons ("Continuer", "Réserver")
   */
  medium: () => {
    if (!canVibrate) return;
    try {
      navigator.vibrate(25);
    } catch (_) {}
  },

  /**
   * Success celebration pulse [15ms, 45ms pause, 30ms] - promo applied, booking confirmed
   */
  success: () => {
    if (!canVibrate) return;
    try {
      navigator.vibrate([15, 45, 30]);
    } catch (_) {}
  },

  /**
   * Warning / Error bump [30ms, 40ms pause, 30ms] - validation error, date unavailable
   */
  warning: () => {
    if (!canVibrate) return;
    try {
      navigator.vibrate([30, 40, 30]);
    } catch (_) {}
  },
};

export default haptic;
